import { Component, Input } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { ChicagoStatus } from '@core/util/chicago';
import { UntilDestroy } from '@ngneat/until-destroy';
import { SelectSnapshot } from '@ngxs-labs/select-snapshot';
import { SelectedMatter } from '@state/matter/matter.selectors';
import { KeyDatesModalComponent } from 'src/app/private/sale/home/key-dates-modal/key-dates-modal.component';
import { ICON } from '@core/util/icon';
import {
	ChicagoPortalComponent,
	ChicagoPortalData,
} from '../../chicago-portal/chicago-portal.component';
import { MissingFieldSection } from '../../services/validate-chicago-data.service';
import { take } from 'rxjs/operators';
import { NavigationService } from 'src/app/shared/services/nav/nav.service';
import { ActivatedRoute } from '@angular/router';
import { BlankTitleInsurance } from '../../chicago.component';
import { BusinessDispatch, BusinessState } from '@state/business';
import { ConfirmFirmModalComponent } from 'src/app/private/profile/integrations/chicago/confirm-firm-modal/confirm-firm-modal.component';
import { ChangePriorityComponent } from 'src/app/private/sale/mortgages/manual/components/change-priority/change-priority.component';
import { TestHooks } from './not-submitted.hooks';
import { DrawerService } from 'src/app/ui/drawer/drawer.service';

@UntilDestroy()
@Component({
	selector: 'app-chicago-not-submitted',
	templateUrl: './not-submitted.component.html',
	styleUrls: ['./not-submitted.component.scss'],
	standalone: false,
})
export class ChicagoNotSubmittedComponent {
	testHooks = TestHooks;
	public ICON = ICON;
	public blankTitleInsurance = BlankTitleInsurance;
	backUrlParams = { 'back-string': 'Title insurance' };
	keyDatesModalParams = { modal: 'keyDates' };
	public chicagoStatus = ChicagoStatus;
	@Input() missing: MissingFieldSection[] = [];
	@Input() orderValid = false;
	@Input() isCommercial = false;
	@Input() outOfOntario = false;
	@Input() showPriorityWarning = false;

	@SelectSnapshot(SelectedMatter.titleInsuranceThirdPartyId)
	thirdPartyId: number;
	@SelectSnapshot(BusinessState.chicagoFirmName) chicagoLawfirm: string;
	@SelectSnapshot(SelectedMatter.id) matterId: string;

	constructor(
		private dialog: MatDialog,
		private route: ActivatedRoute,
		private navService: NavigationService,
		private businessDispatch: BusinessDispatch,
		private drawerService: DrawerService,
	) {}

	openPortal() {
		if (this.orderValid) {
			const data: ChicagoPortalData = {
				submitNewOrder: false,
			};

			if (!this.chicagoLawfirm) {
				const modalRef = this.dialog.open(ConfirmFirmModalComponent, {
					maxWidth: '600px',
					width: '90%',
				});

				modalRef
					.afterClosed()
					.pipe(take(1))
					.subscribe((value) => {
						if (value) {
							this.businessDispatch.SetChicagoFirmName(value);
							this.dialog.open(ChicagoPortalComponent, { data });
						}
					});

				return;
			}
			this.dialog.open(ChicagoPortalComponent, { data });
		}
	}

	changePropertyType() {
		this.navService.goToMatter_Property(this.matterId, this.backUrlParams);
	}

	openKeyDatesDrawer(event: Event) {
		event.preventDefault();

		this.drawerService.openDrawer(KeyDatesModalComponent, {
			size: 'md',
			title: 'Key Dates',
			noStyle: true,
		});
	}

	editPriority(): void {
		this.dialog.open(ChangePriorityComponent, { panelClass: 'gradient' });
	}
}
